var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 66.625C18.3121 66.625 4.375 52.6879 4.375 35.5C4.375 18.3121 18.3121 4.375 35.5 4.375",
    stroke: "#51ACED",
    strokeWidth: 6.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.92 13.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 4.375C52.6879 4.375 66.625 18.3121 66.625 35.5C66.625 52.6879 52.6879 66.625 35.5 66.625",
    stroke: "#51ACED",
    strokeWidth: 6.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 49.3334V23.3959",
    stroke: "#51ACED",
    strokeWidth: 6.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6048 35.5L35.5007 23.3959L23.3965 35.5",
    stroke: "#51ACED",
    strokeWidth: 6.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in-progress.66ce21dbd3e7710d4c4356648fbbd0c6.svg";
export { ForwardRef as ReactComponent };